/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ArrowLargeDownIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAA1UlEQVR4nO2SzwrCMAzGCwo7Cwq+za7FrWkupdFn81n0IIIHPbiBPoHPoWRVqGNz7t+tHwQKTb5fmlSIoCGlkI6g7UGMJUB6cgRArSCMSEoZxXE8HWVEUspIoX2ApkuarudtAdKYhULaA9K2EmCMmbC5M7FXLvgXwLmgKec7hbSrfUWSbGYK7blI1HRbGbNsArjObVbcaXsv17SCQAnQ2rwKAl6hD+hs/gsCb0Bv84/4N/HCnZFb4tdZU171Gbq/BL3o03kjRA9o7o9LoT1x9B5LkPD0Ag/nucNu20WrAAAAAElFTkSuQmCC)
 */
export const ArrowLargeDownIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M12.7 20.7a1 1 0 0 1-1.4 0l-8-8a1 1 0 1 1 1.4-1.4l6.3 6.29V4a1 1 0 1 1 2 0v13.59l6.3-6.3a1 1 0 0 1 1.4 1.42l-8 8Z"
        className={colorClass}
      />
    </svg>
  );
};
